export default function pushTo(array){
	return function (item){
		return array?.push(item);
	}
}
